module.exports = __webpack_public_path__ + "img/stock2.a8949ed9.png";